export enum EventAggregationEventType {
	WEBSOCKET_SERVICE_READY= 'WebsocketServiceReady'
}
